import React from "react";

const LOGO_URL = "https://navscora.com/assets/navscora-logo.png";

export const Brand = ({ collapsed = false, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <img src={LOGO_URL} alt="NavScora" className="h-9 w-auto shrink-0" data-testid="navscora-logo" />
    {!collapsed && (
      <div className="border-l border-[#1D4A57] pl-3 leading-tight">
        <div className="text-[13px] font-bold tracking-tight text-slate-50">
          Admin
        </div>
        <div className="text-[9px] font-semibold uppercase tracking-[0.18em] text-[#25D5C4]/80">
          Business Control
        </div>
      </div>
    )}
  </div>
);
